import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * ProductClickMixin
 *
 * This mixin helps handle clicks on products; allowing the sending of analytics, opening new tabs
 * redirects or overlays to product pages.
 *
 * The simplest way to get started is to include the mixin in your baustein component and implement
 * the function 'getClickOverlayClasses' which should return the classes which link to your product.
 * You also need to include 'overlayEnabled', 'productSlug' and 'reason' options if you want overlays.
 *
 * ```
 *   // ...
 *   mixins: [productClickMixin],
 *
 *   defaultOptions: {
 *      overlayEnabled: false,
 *      productSlug: null,
 *      reason: null
 *   },
 *
 *   getClickOverlayClasses: function () {
 *      return ['.product-color__link'];
 *   }
 *
 * ```
 *
 * If you want specific classes to redirect to product pages you can implement the function
 * 'getClickRedirectClasses' then any clicks to those classes will not open an overlay but will
 * redirect to the product page.
 *
 * ```
 *   getClickRedirectClasses: function () {
 *      return ['.product-color__link2'];
 *   }
 *
 * ```
 *
 * If you want to send analytics for every product click you can do so by implementing the function
 * 'sendAnalytics'.
 *
 * ```
 *  sendAnalytics: function () {
 *      analytics.event('navigation', 'color-picker');
 *  }
 *
 * ```
 *
 */
import _isFunction from "lodash/isFunction";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import history from "web/script/utils/history";
import url from "web/script/utils/url";
var IS_RETURN_TO_FEEDS = environment.getFeature("uf_upper_funnel_journey") && environment.getFeature("uf_return_to_feeds");
/**
 * Product click event handler that will either open an overlay, new tab or redirect to product page.
 */

function _onClick(event, link) {
  if (event.target.classList.contains("show-more-button")) {
    return;
  }

  event.preventDefault();
  this.sendAnalytics();
  var overlayEnabledOption = this.options.overlayEnabled;
  var overlayOnMobileOption = this.options.useOverlayOnMobile;
  var overlayEnabled = overlayEnabledOption && this.options.productSlug && browser.supportsHistory && !event.metaKey && ( // Feature flag to use overlay on mobile too
  overlayOnMobileOption && browser.getViewport() === browser.VIEWPORTS.MOBILE || !browser.ios && !browser.android && browser.getViewport() === browser.VIEWPORTS.DESKTOP);
  this.emit("selected");

  if (!link) {
    return;
  } // if the overlay isn't enabled, and the target is to open a new tab, then bail out here


  if (!overlayEnabled && link.getAttribute("target") === "_blank") {
    // the lead-link click handler also calls `preventDefault` and calls window.open. we don't
    // want to to it twice.
    if (link.getAttribute("is") !== "lead-link") {
      globals.window.open(link);
    }

    return;
  }

  var newTab = _isNewTab(event);

  if (!overlayEnabled || newTab || !this.options.reason || browser.getViewport() === browser.VIEWPORTS.MOBILE) {
    _redirectWithReason.call(this, event, link, newTab);
  } else {
    var href = link.getAttribute("product-href") || link.href;
    var queryParams = {
      reason: this.options.reason,
      link_id: this.options.linkId
    };

    if (IS_RETURN_TO_FEEDS && this.options.fromFeedUrl) {
      queryParams.fromFeedUrl = this.options.fromFeedUrl;
    }

    var _url = new URL(href, window.location.href);

    for (var _i = 0, _Object$entries = Object.entries(queryParams); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          k = _Object$entries$_i[0],
          v = _Object$entries$_i[1];

      _url.searchParams.set(k, v);
    }

    history.pushState(_url);
    this.emit("openOverlay", {
      url: href,
      queryParams: queryParams
    });
  }
}
/**
 * Product click event handler that will either redirect or open a new tab to product page.
 */


function _onClickRedirect(event, link) {
  if (event.target.classList.contains("show-more-button")) {
    return;
  }

  var newTab = _isNewTab(event);

  this.emit("selected");

  _redirectWithReason.call(this, event, link, newTab);
}
/**
 * Returns true if a new tab should be used for the event
 */


function _isNewTab(event) {
  return browser.mac && event.metaKey || !browser.mac && event.ctrlKey || event.which === 2;
}

function _redirectWithReason(event, link, newTab) {
  var openNewTab = newTab || false;
  var parsed = url.parse(link.href);
  event.preventDefault();

  if (IS_RETURN_TO_FEEDS && this.options.fromFeedUrl) {
    parsed.searchParams.set("fromFeedUrl", this.options.fromFeedUrl);
  }

  if (this.options.reason) {
    parsed.searchParams.set("reason", this.options.reason);
  }

  if (openNewTab) {
    globals.window.open(url.unparse(parsed), "_blank");
    return;
  }

  globals.window.location = url.unparse(parsed);
}

export default {
  defaultOptions: {
    overlayEnabled: false,
    productUid: null,
    productSlug: null,
    reason: null,
    linkId: null
  },
  setupEvents: function setupEvents(add) {
    var _this = this;

    if (this.getClickOverlayClasses) {
      this.getClickOverlayClasses().forEach(function (classObj) {
        return add("click", classObj, _onClick.bind(_this));
      });
    }

    if (this.getClickRedirectClasses) {
      this.getClickRedirectClasses().forEach(function (classObj) {
        return add("click", classObj, _onClickRedirect.bind(_this));
      });
    }
  },
  init: function init() {
    var clickMethodName = "getClickOverlayClasses";
    var clickRedirectMethodName = "getClickRedirectClasses";

    if (!_isFunction(this[clickMethodName]) && !_isFunction(this[clickRedirectMethodName])) {
      throw new Error("Missing functions - at least '".concat(clickMethodName, "' or '").concat(clickRedirectMethodName, "' should be implemented"));
    }
  },

  /**
   * Override function in component to send custom analytics on every product click.
   */
  sendAnalytics: function sendAnalytics() {// send your analytics
  }
};